<template>
<w-sliding-popup type="setting" width="600px" ref="slidingPopup" title="고객사 목록" :default-content="false" @close="close">
  <div slot="content" class="body-content" style="height:100%;">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <el-input class="mr-r4" v-model="insertCustomerName" placeholder="추가할 고객사명을 입력하세요." style="width:200px" />
        <el-button class="mr-r4" @click="clickInsertButton" :disabled="insertCustomerName.length === 0">추가</el-button>
        <el-button class="mr-r4" @click="clickDeleteButton" :disabled="checkedRows.length === 0">삭제</el-button>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" type="primary" @click="clickSaveButton" :disabled="!cellEditing.isModified">저장</el-button>
        <el-button class="mr-r4" type="primary" @click="loadData" :disabled="!cellEditing.isModified">취소</el-button>
        <el-button size="mini" @click="showSearchTool = !showSearchTool"><i class="fas fa-search" /></el-button>
      </div>
    </el-row>
    <el-table-wrapper style="height:calc(100% - 28px); width:100%;" :fit-height="true" ref="table" v-loading="isLoading" :data="tableData" :columns="columns"
    :show-custom-header="true" :show-search-tool="showSearchTool" :highlight-current-row="true" @row-click="clickRow" @cell-dblclick="dblclickRow"
    row-class-name="c-pointer" @selection-change="selectionChange" :editable="true">
      <template slot-scope="scope" slot="input-slot">
        <w-input-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" @cell-edit-end="endEdit" />
      </template>
    </el-table-wrapper>
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button class="mr-r4" size="large" type="solid" @click="clickApplyButton">적용</el-button>
    <el-button size="large" @click="closePopup">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import msgUtil from '@/utils/message';
import WInputEditor from '@/components/table/cell-editor/InputEditor';
import SkccCustomerAPI from '@/api/model/skcc-customer';
import CellEditingMixin from '@/mixins/table/cell-editing';

export default {
  name: 'WSkccCustomerSlidingPopup',
  components: {
    WInputEditor,
  },
  mixins: [CellEditingMixin],
  data() {
    return {
      isLoading: false,
      selectedRow: null,
      checkedRows: [],
      showSearchTool: false,
      tableData: [],
      columns: [
        {
          type: 'selection',
        },
        {
          prop: 'customerName',
          editable: true,
          label: '고객사',
          sortable: true,
          searchable: true,
          scopedSlot: 'input-slot',
        },
      ],
      insertCustomerName: '',
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.loadData();
      });
      this.$emit('open');
    },
    close() {
      this.selectedRow = null;
      this.$refs.table.clearFilter();
      this.showSearchTool = false;
      this.$emit('close');
    },
    closePopup() {
      this.$refs.slidingPopup.close();
    },
    loadData() {
      this.isLoading = true;
      const target = '고객사';
      const action = msgUtil.action.VIEW;
      SkccCustomerAPI.getSkccCustomerList().then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          this.tableData = this.getEditableTableData(data, this.columns);
          this.resetCellEditing();
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      }).finally(() => {
        this.isLoading = false;
      });
    },
    clickApplyButton() {
      if (isEmpty(this.selectedRow)) {
        this.$message(msgUtil.getRequireMsgData(msgUtil.action.SELECT, '고객사'));
      } else {
        this.$emit('apply-skcc-customer', this.selectedRow);
        this.closePopup();
      }
    },
    clickSaveButton() {
      const updatedData = this.getUpdatedDatas(this.tableData, true, ['customerId']);

      const target = '고객사';
      const action = msgUtil.action.SAVE;
      SkccCustomerAPI.updateSkccCustomerList(updatedData)
        .then((response) => {
          const result = response.data;
          if (result.success) {
            this.loadData();
          }
          this.$message(msgUtil.getResultMsgData(action, target, result.success));
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
    },
    clickInsertButton() {
      const target = '고객사';
      const action = msgUtil.action.ADD;
      SkccCustomerAPI.insertSkccCustomer({
        customerName: this.insertCustomerName,
      }).then((response) => {
        if (response.data.success) {
          this.insertCustomerName = '';
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.loadData();
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    clickDeleteButton() {
      const target = '고객사';
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        SkccCustomerAPI.deleteSkccCustomerList(this.checkedRows).then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    selectionChange(rows) {
      this.checkedRows = rows;
    },
    clickRow(row) {
      this.selectedRow = row;
    },
    dblclickRow(row, column) {
      this.startEdit(row, column);
    },
    handlerEndEdit() {
      this.checkExistModifiedData(this.tableData);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/popup/SkccCustomerSlidingPopup.vue